import Vue from 'vue'
export default {
  name: 'app',
  state: {
    role: [],
    dict: {},
    company: [],
    stations: [],
    stationsAll: [],
    nodes: [],
    keepAliveExclude: '',
    wsAlarmPop: false,
    wsAlarmPopNum: 0,
    currentTime: 0,
    QRCodeImg: undefined,
    dialog: false,
  },
  mutations: {
    cancelKeepAlive (state, name) {
      state.keepAliveExclude = name
      Vue.nextTick(() => {
        state.keepAliveExclude = ''
      })
    }
  }
}
